import generateRoles from "./rolesTemplate";

export default function generate(Service) {
  let rolesTemplate = generateRoles(Service);
  const state = {
    ...rolesTemplate.state,
    users: []
  };
  const getters = {
    ...rolesTemplate.getters,
    getUsers(state) {
      return state.users;
    }
  };

  const actions = {
    getRoles({ commit }) {
      return Service.authorizations.getRoles(roles => {
        commit("setRoles", {
          roles
        });
      });
    },
    getUsers({ commit }, { id }) {
      return Service.authorizations.getList({ id }, users => {
        commit("setUsers", {
          users
        });
      });
    },

    addUser(_, { id, email, roles }) {
      return Service.authorizations.add({
        id,
        identity: {
          type: "User",
          email
        },
        roles
      });
    },
    addUserGroup(_, { id, userGroupId, roles }) {
      return Service.authorizations.setUserGroup({
        id,
        identity: {
          type: "UserGroup",
          id: userGroupId
        },
        roles
      });
    },
    deleteUserGroup(_, { id, user_id }) {
      return Service.authorizations.deleteUserGroup({
        id,
        identity: {
          type: "UserGroup",
          id: user_id
        }
      });
    },
    editUserGroup(_, { id, user_id, roles }) {
      return Service.authorizations.editUserGroup({
        id,
        identity: {
          type: "UserGroup",
          id: user_id
        },
        roles
      });
    },
    editUser(_, { id, user_id, roles }) {
      return Service.authorizations.edit({
        id,
        identity: {
          type: "User",
          id: user_id
        },
        roles
      });
    },
    deleteUser(_, { id, user_id }) {
      return Service.authorizations.delete({
        id,
        identity: {
          type: "User",
          id: user_id
        }
      });
    }
  };

  const mutations = {
    ...rolesTemplate.mutations,
    setUsers(state, { users }) {
      state.users = users;
    }
  };
  return {
    state,
    getters,
    actions,
    mutations
  };
}
